import { DeviceError, DeviceErrorCode, DeviceErrorDescription } from './error';
import { IError, DeviceType } from './interface';

export class DeviceManager {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}
  public getCameraList(): Promise<Array<MediaDeviceInfo>> {
    return new Promise((resolve, reject) => {
      if (this.checkSupport()) {
        this.getDeviceRight(DeviceType.Camera)
          .then(() => {
            this.getDeviceList(DeviceType.Camera)
              .then(list => {
                resolve(list);
              })
              .catch(err => {
                reject(this.parseError(DeviceType.Camera, err));
              });
          })
          .catch(err => {
            reject(this.parseError(DeviceType.Camera, err));
          });
      } else {
        reject(
          new DeviceError(
            DeviceErrorCode.ERROR_DEVICE_NOTSUPPORT,
            'not support navigator.mediaDevices'
          )
        );
      }
    });
  }

  public getMicList(): Promise<Array<MediaDeviceInfo>> {
    return new Promise((resolve, reject) => {
      if (this.checkSupport()) {
        this.getDeviceRight(DeviceType.Mic)
          .then(() => {
            this.getDeviceList(DeviceType.Mic)
              .then(list => {
                resolve(list);
              })
              .catch(err => {
                reject(this.parseError(DeviceType.Mic, err));
              });
          })
          .catch(err => {
            reject(this.parseError(DeviceType.Mic, err));
          });
      } else {
        reject(
          new DeviceError(
            DeviceErrorCode.ERROR_DEVICE_NOTSUPPORT,
            'not support navigator.mediaDevices'
          )
        );
      }
    });
  }

  protected getDeviceRight(
    deviceType: DeviceType
  ): Promise<IError | undefined> {
    return new Promise((resolve, reject) => {
      let constraints;
      if (DeviceType.Camera === deviceType) {
        constraints = { video: true };
      } else if (DeviceType.Mic === deviceType) {
        constraints = { audio: true };
      }
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(mediastream => {
          mediastream.getTracks().forEach(track => {
            track.stop();
          });
          resolve(undefined);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  protected checkSupport(): boolean {
    if (
      navigator &&
      navigator.mediaDevices &&
      // @ts-ignore
      navigator.mediaDevices.enumerateDevices &&
      // @ts-ignore
      navigator.mediaDevices.getUserMedia
    ) {
      return true;
    }
    return false;
  }

  protected getDeviceList(
    deviceType: DeviceType
  ): Promise<Array<MediaDeviceInfo>> {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices
        .enumerateDevices()
        .then(deviceList => {
          const arr: Array<MediaDeviceInfo> = [];
          deviceList.forEach((device: MediaDeviceInfo) => {
            if (device.kind === deviceType) {
              arr.push(device);
            }
          });
          resolve(arr);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  protected parseError(deviceType: DeviceType, err: Error): IError {
    let error: IError | null = null;
    if (DeviceType.Mic === deviceType) {
      error = this.parseAudioError(err);
    } else if (DeviceType.Camera === deviceType) {
      error = this.parseVideoError(err);
    } else if (DeviceType.Screen === deviceType) {
      error = this.parseScreenError(err);
    }
    if (null === error) {
      return new DeviceError(DeviceErrorCode.ERROR_DEVICE_UNKNOWNERROR, '');
    }
    return error;
  }

  protected parseAudioError(err: Error): IError | null {
    if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTFOUND ||
      err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTFOUND
    ) {
      return new DeviceError(
        DeviceErrorCode.ERROR_DEVICE_AUDIODEVICE_NOTFOUND,
        '未找到音频设备'
      );
    } else if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTALLOWED ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACSAFARI_DEVICENOTALLOWED
    ) {
      return new DeviceError(
        DeviceErrorCode.ERROR_DEVICE_AUDIODEVICE_NOTALLOWED,
        '不允许使用音频设备'
      );
    } else if (
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACCHROME_DEVICENOTREADABLE ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_AUDIODEVICENOTREADABLE ||
      err.message === DeviceErrorDescription.ERRORNAME_DEVICENOTREADABLE
    ) {
      return new DeviceError(
        DeviceErrorCode.ERROR_DEVICE_AUDIODEVICE_NOTREADABLE,
        '音频设备不可读'
      );
    }
    return null;
  }

  protected parseVideoError(err: Error): IError | null {
    if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTFOUND ||
      err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTFOUND
    ) {
      return new DeviceError(
        DeviceErrorCode.ERROR_DEVICE_VIDEODEVICE_NOTFOUND,
        '未找到视频设备'
      );
    } else if (
      err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTALLOWED ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MOBILEDEVICE_NOTALLOWED ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACSAFARI_DEVICENOTALLOWED
    ) {
      return new DeviceError(
        DeviceErrorCode.ERROR_DEVICE_VIDEODEVICE_NOTALLOWED,
        '不允许使用视频设备'
      );
    } else if (
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_MACCHROME_DEVICENOTREADABLE ||
      err.message ===
        DeviceErrorDescription.ERRORMESSAGE_VIDEODEVICENOTREADABLE ||
      err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTREADABLE
    ) {
      return new DeviceError(
        DeviceErrorCode.ERROR_DEVICE_VIDEODEVICE_NOTREADABLE,
        '视频设备不可读'
      );
    } else if (
      err.name === DeviceErrorDescription.ERRORNAME_DEVICEOVERCONSTRAINED
    ) {
      return new DeviceError(
        DeviceErrorCode.ERROR_DEIVCE_CONSTRAINEDERROR,
        'constraints error'
      );
    }
    return null;
  }

  protected parseScreenError(err: Error): IError | null {
    if (err.name === DeviceErrorDescription.ERRORNAME_DEVICENOTALLOWED) {
      if (
        err.message === DeviceErrorDescription.ERRORMESSAGE_DEVICENOTALLOWED
      ) {
        return new DeviceError(
          DeviceErrorCode.ERROR_SCREENSHARE_NOTALLOWED,
          err.message
        );
      } else {
        return new DeviceError(
          DeviceErrorCode.ERROR_SCREENSHARE_NOPERMISSION,
          err.message
        );
      }
    } else if (err.name === DeviceErrorDescription.ERRORNAME_INVALID_ACCESS) {
      return new DeviceError(
        DeviceErrorCode.ERROR_SCREENSHARE_INVALIDACCESS,
        err.message
      );
    }
    return null;
  }
}
